<!-- Main view when user is logged in -->
<template>
  <v-app>
    <admin-menu />

    <v-main class="ma-4">
      <router-view name="admin" />
    </v-main>
    <admin-footer />
  </v-app>
</template>
<script>
import AdminMenu from '@/components/Admin/Menu/AdminMenu';
import AdminFooter from '@/components/Admin/Menu/AdminFooter';

export default {
  components: {
    AdminMenu,
    AdminFooter,
  },
  data() {
    return {
      username: '',
    };
  },
  async created() {
    // if (!this.$store.getters.isLoggedIn) {
    //  this.$router.push('/login');
    // }
    this.username = this.$store.getters.getUser.username;
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
};
</script>
